const MODULE_NAME = 'WebsocketModule';

// eslint-disable-next-line import/prefer-default-export
export const GET_WEBSOCKET_STATUS = `${MODULE_NAME}/GET_WEBSOCKET_STATUS`;
export const GET_WEBSOCKET_CONNECTION_ID = `${MODULE_NAME}/GET_WEBSOCKET_CONNECTION_ID`;
